import React from 'react';
import IntegrateRoutes from './IntegrateRoutes';
import { ROUTE_REDESIGN } from 'js/constants/pathnames';
import { ROUTE_CONNECT } from 'new/constants/pathnames';
import { DrawerWithNewDataFlowButton } from 'new/components/integrate/DrawerWithNewDataFlowButton';
import { useSectionNavigation } from 'new/hooks/useSectionNavigation';

const basePath = `${ROUTE_REDESIGN}${ROUTE_CONNECT}`;
export const SELECT_FLOW_TYPES_URI = `${basePath}/flows/select-type`;

export default function Integrate() {
  useSectionNavigation('integrate');

  return (
    <DrawerWithNewDataFlowButton>
      <IntegrateRoutes />
    </DrawerWithNewDataFlowButton>
  );
}
